import React from 'react'
import './Steps.css'

function Steps() {
  return (
    <main>
        <div className='steps-container container' id='main'>
            <div className="steps-title">
                <h2>WHAT DO WE OFFER</h2>
                <div className='title_line'></div>
            </div>
            <div className="steps">
                <div className="step1">
                    <div className="card">
                        <h4>Calculate how much you'll be making working with us</h4>
                        <p>Use our online income calculator. Put in how many miles are you willing to run in a week, and know yourself how much you'll be making weekly</p>
                    </div>
                </div>
                <div className="step2 position_right">
                    <div className="card">
                        <h4>Year-Round Dedicated Lanes all over the USA</h4>
                        <p>We have a lot of dedicated lanes, with year round contact, which allows you have a stable income. Start with the company, show what you can do in 3-4 weeks. The dispatcher will reach out to you with offer for dedicated lane, based on your working style capability</p>
                    </div>
                </div>
                <div className="step3">
                    <div className="card">
                        <h4>Carrier Services</h4>
                        <p>If you are a customer with a decent volume of products that needs to be delivered from point A to B, feel free to reach out, since we offer our carrier services as well</p>
                    </div>
                </div>
            </div>
            <div className="bg_swimmers">
                <svg className="swimmer1 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
                <svg className="swimmer2 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
                <svg className="swimmer3 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
                <svg className="swimmer4 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
            </div>
        </div>
    </main>
    
  )
}

export default Steps